/**
 * With FCM, you can send two types of messages to clients:
 * - Notification messages, sometimes thought of as "display messages." These are handled by the FCM SDK automatically. Notification messages have a predefined set of user-visible keys and an optional data payload of custom key-value pairs.
 * - Data messages are handled by the client app. Data messages have only custom key-value pairs with no reserved key names.
 *
 * @reference https://firebase.google.com/docs/cloud-messaging/concept-options#notifications_and_data_messages
 */
export enum FirebaseNotificationType {
  /** Messages are displayed and handled by the operating system directly. Corresponds to `androidUseOsNotifications === true`. */
  NOTIFICATION = 'notificationMessages',
  /** Messages are handled by the application. Corresponds to `androidUseOsNotifications === false`. */
  DATA = 'dataMessages',
}

export enum IntegrationFormField {
  authType = 'authType',
  bundleID = 'bundleID',
  certificate = 'certificate',
  firebaseJsonFile = 'firebaseJsonFile',
  firebaseNotificationType = 'firebaseNotificationType',
  keyID = 'keyID',
  p12file = 'p12file',
  p12password = 'p12password',
  p8File = 'p8File',
  privateKey = 'privateKey',
  teamID = 'teamID',
}
